/* eslint-disable */
import $ from 'jquery';
var handler = function (event) {
  window.PopupController.PopupJsClick(this);
  event.stopPropagation();
};
export default {
  run: function ($scope) {
    $scope = $scope || $('body');
    if ($scope.jquery) {
      var helpLinks = $scope.find('a[data-help]');
      helpLinks.off('click', handler).on('click', handler);
    }
  }
};

